/** معرف موقع Firebase hosting للمنيو العام (بدون underscores — Firebase يقبل - فقط) */
export const MENU_HOSTING_SITE_ID = 'madentak-ban-edak'
export const ADMIN_HOSTING_SITE_ID = 'foodorderapp-2b2df'

function normalizeHost(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/\/.*$/, '')
}

export function getMenuSiteHostnames() {
  const hosts = new Set()
  const fromEnv = normalizeHost(import.meta.env.VITE_MENU_SITE_HOST)
  if (fromEnv) hosts.add(fromEnv)

  hosts.add(`${MENU_HOSTING_SITE_ID}.web.app`)
  hosts.add(`${MENU_HOSTING_SITE_ID}.firebaseapp.com`)

  return hosts
}

/** هل التطبيق يعمل على نطاق موقع المنيو العام (وليس لوحة الإدارة)؟ */
export function isMenuPublicSite() {
  if (import.meta.env.VITE_APP_SHELL === 'menu') return true
  if (typeof window === 'undefined') return false

  const current = normalizeHost(window.location.hostname)
  return getMenuSiteHostnames().has(current)
}

const gustoAdminBase = () => String(import.meta.env.VITE_LMENUS_ADMIN_BASE_URL || '').trim().replace(/\/$/, '')

/** Is this Gusto!'s own address (website or control panel), not a Madentak one? */
export function isGustoHost() {
  if (typeof window === 'undefined') return false
  const current = normalizeHost(window.location.hostname)
  return [import.meta.env.VITE_LMENUS_PUBLIC_BASE_URL, import.meta.env.VITE_LMENUS_ADMIN_BASE_URL]
    .map(normalizeHost)
    .includes(current)
}

/** قاعدة لوحة الإدارة (لوجين LMenus + /business) */
export function getAdminBaseUrl() {
  if (gustoAdminBase() && isGustoHost()) return gustoAdminBase()

  const fromEnv = String(import.meta.env.VITE_ADMIN_BASE_URL || '').trim()
  if (fromEnv) return fromEnv.replace(/\/$/, '')

  if (typeof window !== 'undefined' && !isMenuPublicSite()) {
    return window.location.origin.replace(/\/$/, '')
  }

  return `https://${ADMIN_HOSTING_SITE_ID}.web.app`
}

export function getLmenusLoginUrl() {
  return `${gustoAdminBase() || getAdminBaseUrl()}/gusto/login`
}

export function getLmenusAdminPanelHomeUrl() {
  return `${gustoAdminBase() || getAdminBaseUrl()}/business/home`
}
